import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export type MapViewType = 'search-results' | 'my-routes' | 'selected-route';

interface MapViewControlProps {
  currentView: MapViewType;
  onViewChange: (view: MapViewType) => void;
  myRoutesCount: number;
  selectedRouteName?: string;
}

export default function MapViewControl({
  currentView,
  onViewChange,
  myRoutesCount,
  selectedRouteName,
}: MapViewControlProps) {
  const [isOpen, setIsOpen] = useState(false);

  const getCurrentLabel = () => {
    switch (currentView) {
      case 'search-results':
        return 'Search Results';
      case 'my-routes':
        return `My Routes (${myRoutesCount})`;
      case 'selected-route':
        return selectedRouteName ? `Selected Route: ${selectedRouteName}` : 'Selected Route';
      default:
        return 'Search Results';
    }
  };

  const handleOptionClick = (view: MapViewType) => {
    onViewChange(view);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 transition-colors"
      >
        <span className="text-sm font-medium text-gray-700">
          Showing: {getCurrentLabel()}
        </span>
        <ChevronDown className={`w-4 h-4 text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 z-[1000]" 
            onClick={() => setIsOpen(false)}
          />
          
          {/* Dropdown */}
          <div className="absolute right-0 top-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-[1001] min-w-48">
            <div className="py-1">
              <button
                onClick={() => handleOptionClick('search-results')}
                className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-50 ${
                  currentView === 'search-results' ? 'bg-primary-50 text-primary-700' : 'text-gray-700'
                }`}
              >
                Search Results
              </button>
              <button
                onClick={() => handleOptionClick('my-routes')}
                className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-50 ${
                  currentView === 'my-routes' ? 'bg-primary-50 text-primary-700' : 'text-gray-700'
                }`}
              >
                My Routes ({myRoutesCount})
              </button>
              {selectedRouteName && (
                <button
                  onClick={() => handleOptionClick('selected-route')}
                  className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-50 ${
                    currentView === 'selected-route' ? 'bg-primary-50 text-primary-700' : 'text-gray-700'
                  }`}
                >
                  Selected Route: {selectedRouteName}
                </button>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
